import { modelKey, catalogChanges } from './editorState';

export const workspaceCatalog = data => ({ ...data,
  placements: data.operations?.draft ?? data.placements,
  bundleSelection: data.operations?.draftBundle ?? data.bundleSelection,
  archivedPlacements: data.operations?.archivedPlacements ?? [],
  archivedModels: data.operations?.archivedModels ?? [],
});
export const isArchived = (catalog, placement) => catalog.archivedPlacements?.includes(placement.id);
export const isModelArchived = (catalog, model) => catalog.archivedModels?.some(ref => modelKey(ref) === modelKey(model));
export const hasPublicationChanges = data => !!data?.operations && (
  JSON.stringify(data.placements) !== JSON.stringify(data.operations.draft) ||
  JSON.stringify(data.bundleSelection) !== JSON.stringify(data.operations.draftBundle));
export function placementStatus(placement, published, catalog) {
  if (isArchived(catalog, placement)) return '보관';
  const before = published?.placements.find(p => p.id === placement.id);
  if (!before) return '새 초안';
  if (JSON.stringify(before) !== JSON.stringify(placement)) return before.active ? '게시 중 · 수정안' : '중단 · 수정안';
  return before.active ? '게시 중' : '중단';
}
export function stagePlacement(catalog, placement, action) {
  if (action === 'delete-placement') return { ...catalog,
    placements: catalog.placements.filter(p => p.id !== placement.id),
    archivedPlacements: catalog.archivedPlacements.filter(id => id !== placement.id) };
  return { ...catalog,
    placements: catalog.placements.map(p => p.id === placement.id ? { ...p, active: false } : p),
    archivedPlacements: action === 'archive-placement'
      ? [...catalog.archivedPlacements.filter(id => id !== placement.id), placement.id]
      : catalog.archivedPlacements.filter(id => id !== placement.id) };
}
export function modelUses(data, model) {
  if (!data || !model) return { published: [], draft: [], included: false };
  const matches = p => p.modelId === model.id && p.modelVersion === model.version;
  return { published: data.placements.filter(matches), draft: (data.operations?.draft ?? data.placements).filter(matches),
    included: [...data.bundleSelection, ...(data.operations?.draftBundle ?? [])].some(ref => modelKey(ref) === modelKey(model)) };
}
export function canRetireModel(data, model) {
  const uses = modelUses(data, model);
  return !uses.included && ![...uses.published, ...uses.draft].some(p => p.active);
}
export function setUniformScale(placement, value) {
  if (value === '') return ['', '', ''];
  // Preserve proportions, including an existing axis correction.
  const reference = placement.scale[0];
  if (!(reference > 0)) return [value, value, value];
  return placement.scale.map(n => Math.round(n / reference * value * 1000000) / 1000000);
}
export const draftPayload = catalog => ({ revision: catalog.revision,
  placements: catalog.placements, bundleSelection: catalog.bundleSelection,
  archivedPlacements: catalog.archivedPlacements, archivedModels: catalog.archivedModels });

export const operationLabel = action => ({ 'save-draft': '초안 저장', publish: '게시', 'discard-draft': '초안 폐기', 'restore-history': '이전 게시본 복원 준비', 'delete-model': '모델 영구 삭제' }[action] || '운영 작업');

export function operationTime(value) {
  if (!value) return '시각 미기록';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '시각 확인 필요';
  return `${new Intl.DateTimeFormat('ko-KR', { dateStyle: 'short', timeStyle: 'medium', timeZone: 'Asia/Seoul' }).format(date)} KST`;
}

export function publishedChanges(draft, published) {
  // Archive membership is saved Admin metadata; it is not a pending publication.
  return catalogChanges(draft, { ...published,
    archivedPlacements: draft?.archivedPlacements,
    archivedModels: draft?.archivedModels,
  });
}
